module.exports = __webpack_public_path__ + "img/reminder.36f72262.png";